(() => {
  if (customElements.get('telysi-customer-carousel')) return;
  customElements.define('telysi-customer-carousel', class extends HTMLElement {
    connectedCallback() {
      if (!this.querySelector('.telysi-customer-carousel__dots')) {
        this.observer = new MutationObserver(() => {
          if (this.querySelector('.telysi-customer-carousel__dots')) {
            this.observer.disconnect();
            this.initialize();
          }
        });
        this.observer.observe(this, { childList: true, subtree: true });
        return;
      }
      this.initialize();
    }
    disconnectedCallback() { this.observer?.disconnect(); clearInterval(this.timer); }
    initialize() {
      if (this.ready) { this.startAutoplay(); return; }
      this.ready = true;
      this.cards = [...this.querySelectorAll('.telysi-customer-carousel__card')];
      this.dots = [...this.querySelectorAll('.telysi-customer-carousel__dots button')];
      this.index = 0;
      this.dots.forEach((dot, index) => dot.addEventListener('click', () => { this.show(index); this.startAutoplay(); }));
      this.addEventListener('keydown', event => {
        if (!['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
        event.preventDefault();
        this.show(this.index + (event.key === 'ArrowRight' ? 1 : -1));
        this.dots[this.index]?.focus();
      });
      this.addEventListener('touchstart', e => { this.touchX = e.changedTouches[0].clientX; }, { passive: true });
      this.addEventListener('touchend', e => {
        const delta = e.changedTouches[0].clientX - this.touchX;
        if (Math.abs(delta) > 45) this.show(this.index + (delta < 0 ? 1 : -1));
      }, { passive: true });
      this.startAutoplay();
    }
    startAutoplay() {
      clearInterval(this.timer);
      if (matchMedia('(prefers-reduced-motion: reduce)').matches || this.cards.length < 2) return;
      this.timer = setInterval(() => {
        const rect = this.getBoundingClientRect();
        if (document.hidden || this.matches(':hover') || this.contains(document.activeElement) || rect.bottom <= 0 || rect.top >= innerHeight) return;
        this.show(this.index + 1);
      }, 4000);
    }
    show(index) {
      this.index = (index + this.cards.length) % this.cards.length;
      this.cards.forEach((card, i) => { card.hidden = i !== this.index; });
      this.dots.forEach((dot, i) => dot.setAttribute('aria-pressed', String(i === this.index)));
    }
  });
})();
